// extracted by mini-css-extract-plugin
export default {"topRoute":"TopRoute_topRoute__uG10+","arrow":"TopRoute_arrow__1j1of"};